export const getModelTasksColumns = () => {
  return [
    {
      'Header': 'TAREA',
      'accessor': 'serviceCode3',
      'width': 1,
    },
    {
      'Header': 'DESCRIPCIÓN',
      'accessor': 'description',
      'width': 7,
    },
    {
      'Header': 'ÁREA',
      'accessor': 'area',
      'width': 2,
    },
    {
      'Header': 'ESTADO TAREA',
      'accessor': 'status',
      'Filter': () => null,
    },
    {
      'Header': 'FLAT RATE STD',
      'accessor': 'stdFlat',
      'width': 1,
      'Filter': () => null,
    },
    {
      'Header': 'FLAT RATE LOCAL',
      'accessor': 'localFlat',
      'width': 1,
      'Filter': () => null,
    },
    {
      'Header': 'PRECIO',
      'accessor': 'price',
      'width': 1,
      'Filter': () => null,
    },
  ];
};

